import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { TopLevelFunnelLanding } from './types';

export function useTopLevelFunnelLandingData(): Page<TopLevelFunnelLanding>['templateFields'] {
  return useCurrentPage<Page<TopLevelFunnelLanding>>().templateFields;
}
